// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fill-remaining-space {
  /*This fills the remaining space, by using flexbox.  
       Every toolbar row uses a flexbox row layout. */
  flex: 1 1 auto;
}

img {
  height: 3.7rem;
  margin-top: 0.5rem;
  width: 20rem;
}

.user {
  margin-right: -15px;
  color: #FFFFFF;
  font-size: 16px;
}

.wlc {
  text-align: right;
  color: #00C1D4;
  font-size: 16px;
  margin-left: 100px;
}

.expresslogo {
  height: 3.5rem;
  margin-top: 0.5rem;
  width: 11.2rem;
}

.username {
  text-align: right;
  /*width: 200px;*/
  margin-right: 10px;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/navbar/navbar.component.scss"],"names":[],"mappings":"AAAA;EACI;qDAAA;EAEA,cAAA;AACJ;;AAEE;EACE,cAAA;EACA,kBAAA;EACA,YAAA;AACJ;;AACE;EACE,mBAAA;EAEE,cAAA;EACA,eAAA;AACN;;AAEE;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AACJ;;AAEE;EACI,cAAA;EACA,kBAAA;EACA,cAAA;AACN;;AACE;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAEJ","sourcesContent":[".fill-remaining-space {\n    /*This fills the remaining space, by using flexbox.  \n         Every toolbar row uses a flexbox row layout. */\n    flex: 1 1 auto;\n  }\n  \n  img{\n    height: 3.7rem;\n    margin-top: .5rem;\n    width:20rem;\n  }\n  .user{\n    margin-right:-15px;\n      // text-align: center;\n      color:#FFFFFF;\n      font-size:16px;\n  }\n  \n  .wlc{\n    text-align: right;\n    color:#00C1D4;\n    font-size:16px;\n    margin-left:100px; \n  }\n  \n  .expresslogo{\n      height: 3.5rem;\n      margin-top: .5rem;\n      width:11.2rem;\n  }\n  .username{\n    text-align: right;\n    /*width: 200px;*/\n    margin-right: 10px;\n    font-size:16px;\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
